import { useEffect } from 'react';

import { AsicsLogoBlue, Link, RunkeeperLogo, styled } from '@asicsdigital/oneasics-blocks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTracking } from 'react-tracking';

import LoginForm from '../../components/form/LoginForm';
import { FormDisclaimerText } from '../../components/form/shared';
import PageWrapper from '../../components/page-wrapper/PageWrapper';
import { useCopyWithLinks } from '../../hooks/use-copy-with-links';
import { useCountryOverrides } from '../../hooks/use-country-overrides';

const ForgotPasswordRow = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '-12px',
});

const AutoOptInWrapper = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes.xxSmall,
  marginBottom: '10px',
}));

const LogoContainer = styled.div({
  marginBottom: '40px',
  textAlign: 'center',
  '> img': {
    display: 'inline',
    height: '22px',
    margin: '0px 12px',
  },
});

const Login = () => {
  const copyWithLinks = useCopyWithLinks({ view: 'login', copyKeys: ['additionalDisclaimer'] });
  const history = useHistory();
  const {
    queryParams: { autoOptIn, style },
    ui: { emailFromLander },
  } = useSelector((state) => state);
  const { i18n } = useTranslation();
  const t = i18n.updateT(style);
  const { Track } = useTracking(
    { event_name: 'login', event_type: 'pageview', page: 'login' },
    { dispatchOnMount: true },
  );

  useEffect(() => {
    if (!emailFromLander) {
      history.push('/');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const formCopy = useCountryOverrides('register', style);

  return (
    <Track>
      <PageWrapper subtitleText={t('login.subtitle')} titleText={t('login.title')}>
        <LogoContainer>
          <img alt="asics-logo" src={AsicsLogoBlue} />
          <img alt="runkeeper-logo" src={RunkeeperLogo} />
        </LogoContainer>

        <LoginForm>
          <ForgotPasswordRow>
            <Link
              color="textPrimary"
              fontSize='xxSmall'
              name='forgot-password'
              path='/forgot-password'
              type="link"
            >
              {t('login.forgotPassword')}
            </Link>
          </ForgotPasswordRow>

          {
            copyWithLinks.additionalDisclaimer?.length > 0 &&
            <FormDisclaimerText>{copyWithLinks.additionalDisclaimer}</FormDisclaimerText>
          }

          {
            autoOptIn === 'true' &&
            <AutoOptInWrapper>
              {formCopy.autoOptIn}
            </AutoOptInWrapper>
          }
        </LoginForm>
      </PageWrapper>
    </Track>
  );
};

Login.propTypes = {};

export default Login;
